import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import M_ButtonNormal from 'components/1_Atoms/2_Molecules/M_ButtonNormal'
import O_TablePagination from './O_TablePagination'
import { organismLog } from 'utils/logUtil'
import M_ButtonAlert from 'components/1_Atoms/2_Molecules/M_ButtonAlert'
import { useGetIsHiddenPagination } from 'hooks/useRitsuJoken'
import { buttonQueryF, clickFetchF, voidF } from 'types/FunctionTypes'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    hit: {
      marginRight: theme.spacing(1),
      // width: 400,
    },
    buttons: {
      // flexGrow: 1,
      // width: 190
    },
    paddingRight0: {
      paddingRight: '0px',
    },
  }),
)
const margin = 0
const paddingX = 0.5
const paddingY = 0.5

type Props = {
  count: number
  checkedList?: boolean[]
  clickShonin: clickFetchF
  clickHinin: clickFetchF
  clickKakuninzumi: clickFetchF
  clickCSV: buttonQueryF
  clickJochoShonin: clickFetchF
  clickJochoHinin: clickFetchF
  refetch: voidF
}

const O_TableBar = ({ count, checkedList = [false, false, false], clickCSV, clickShonin, clickHinin, clickKakuninzumi, clickJochoShonin, clickJochoHinin, refetch }: Props) => {
  useEffect(() => organismLog('O_TableBarRitsu'))
  const classes = useStyles()
  const userKind = useSelector((state) => state.LoginReducer.userKind)
  const isHiddenPagination = useGetIsHiddenPagination()
  const isJocho = useSelector((state) => state.LoginReducer.isJocho)

  return (
    <div className={classes.root}>
      <Toolbar variant="dense" className={classes.paddingRight0}>
        <Typography className={classes.hit} color="inherit" variant="subtitle1" component="div">
          {count}件 見つかりました。
        </Typography>
        <Box className={classes.buttons} m={margin} px={paddingX} py={paddingY}>
          <M_ButtonNormal label={'CSV出力'} event={clickCSV} disabled={checkedList[0]} />
        </Box>
        <Box className={classes.buttons} m={margin} px={paddingX} py={paddingY}>
          {userKind === 0 ? <M_ButtonNormal label={'確認済'} event={(e) => clickKakuninzumi(e, refetch)} disabled={checkedList[1]} /> : <M_ButtonNormal label={'承認'} event={(e) => clickShonin(e, refetch)} disabled={checkedList[1]} />}
        </Box>
        <Box className={classes.buttons} m={margin} px={paddingX} py={paddingY}>
          {userKind === 0 ? null : <M_ButtonAlert label={'否認'} event={(e) => clickHinin(e, refetch)} disabled={checkedList[2]} />}
        </Box>
        <Box className={classes.buttons} m={margin} px={paddingX} py={paddingY}>
          {isJocho ? <M_ButtonNormal label={'上長承認'} event={(e) => clickJochoShonin(e, refetch)} disabled={checkedList[3]} /> : null}
        </Box>
        <Box className={classes.buttons} m={margin} px={paddingX} py={paddingY}>
          {isJocho ? <M_ButtonAlert label={'上長否認'} event={(e) => clickJochoHinin(e, refetch)} disabled={checkedList[4]} /> : null}
        </Box>
        <Box className={classes.root}></Box>
        <Box>{isHiddenPagination ? null : <O_TablePagination count={count} isDetail={false} />}</Box>
      </Toolbar>
    </div>
  )
}
export default React.memo(O_TableBar)
